import React, { useEffect, useState } from 'react';
import {  RefreshCw, Settings } from 'lucide-react';
import { getSupportRequests, SupportRequest } from '../hooks/api-methods/useSupport';
import { useScreenSize } from '../hooks/useScreenSize';
import { ScrollableList } from '../componentsNew/Lists/scrollableList';
import Loader from '../componentsNew/Loader/Loader';

const OverviewManager: React.FC = () => {
  const { isMobile } = useScreenSize();
  const [loading, setLoading] = useState<boolean>(true);
  const [support, setSupport] = useState<SupportRequest[]>([]);

  useEffect(() => {
    const fetchSupport = async () => {
      try {
        const data = await getSupportRequests();
        setSupport(data);
      } catch (err) {
        console.error('Error fetching support requests:', err);
      } finally {
        setLoading(false); 
      }
    };

    fetchSupport();
  }, []);


  if (loading) {
    return <Loader />; 
  }


  return (
    <div className="flex-row">
      <div className="flex-colomn gap-2 w-100">
        <div className={`${isMobile ? 'flex-colomn' : 'flex-row space-between'}`}>
          <h3>Support Messages</h3>
          <div className="flex-row-align justify-end">
            <button
              className="btn btn-small btn-second-color flex items-center justify-center gap-2"
              onClick={() => window.location.reload()}
              title="Refresh"
            >
              <RefreshCw className="w-4 h-4" />
            </button>

            <button
              className="btn btn-small btn-second-color flex items-center justify-center gap-2"
              onClick={() => (window.location.href = '/dashboard/support')}
              title="Manage"
            >
              <Settings className="w-4 h-4" />
            </button>
          </div>
        </div>

        <ScrollableList
          items={support}
          renderItem={(item) => (
            <div className="flex-row w-100">
              <strong className="w-100 text-ellipsis">{item.name}</strong>
              <p className="w-100 text-ellipsis">
                {item.email} - ({item.phone})
              </p>
              <p className="w-100 text-ellipsis">{item.subject}</p>
              <div className="flex-row">
                <button
                  className="btn btn-small btn-second-color"
                  onClick={() => {
                    const encodedSubject = encodeURIComponent(item.subject);
                    window.location.href = `/dashboard/support?subject=${encodedSubject}`;
                  }}
                >
                  Reply
                </button>
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default OverviewManager;
